<template>
	<div class="history-stories layout-row layout-hv-center">
		<img src="../../assets/building.png" alt="">
	</div>
</template>

<script>
export default {
	data() {
		return {};
	},
	computed: {},
	methods: {},
	created() { },
	mounted() { },
	components: {}
};
</script>

<style lang="scss" scoped>
img {
	width: 40vw;
}
</style>